import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { toast } from '@/components/Toaster/Toast';

import { sensorService } from '@/controllers/sensorService';

import { useHardware } from '@/hooks/useHardware/useHardware';
import { useSensors } from '@/hooks/useSensors';
import { useSessionScreenStore } from '@/hooks/useSessionScreenStore';

import { useUserInfoContext } from '@/contexts/userInfoContext';

import { HubConnectScreen } from './HubConnectScreen';
import { ProcessAndUploadScreen } from './ProcessAndUploadScreen';
import { RecordingScreen } from './RecordingScreen';
import { SensorScreen } from './SensorScreen';

interface ScreensProps {
  isHubFlow: boolean;
}

interface LocationState {
  clientName?: string;
  clientId?: string;
  resetActiveSession?: boolean;
  measurementType: string;
  sessionId: string;
  date: string;
}

export const Screens = ({ isHubFlow }: ScreensProps) => {
  const { currentScreen } = useSessionScreenStore();
  const { getConfig } = useHardware();
  const [config, setConfig] = useState<ReturnType<typeof getConfig> | null>(null);
  const location = useLocation<LocationState>();
  const { init } = useSensors(isHubFlow);

  const { state } = location;
  const { userInfo } = useUserInfoContext();

  useEffect(() => {
    // TODO: Get config should come from the useDatabase hook in the future.
    const newConfig = getConfig();
    console.log('Config:', newConfig);
    setConfig(newConfig);
  }, []);

  useEffect(() => {
    if (config && state?.clientName) {
      init(
        state.sessionId,
        new Date(state.date),
        config,
        state.clientName,
        userInfo.id,
        state.clientId!,
        userInfo.token!,
      );
    }
  }, [config, state]);

  switch (currentScreen?.id) {
    case 0:
      return <HubConnectScreen isHubFlow={isHubFlow} />;
    case 1:
      return <SensorScreen isHubFlow={isHubFlow} />;
    case 2:
      return <RecordingScreen isHubFlow={isHubFlow} />;
    case 3:
      return <ProcessAndUploadScreen isHubFlow={isHubFlow} />;
    case -1:
      return <SensorScreen isHubFlow={isHubFlow} isRecalibration />;
    default:
      return null;
  }
};
